
export default {
  state: {
    conversation: [],
    isWaitingForResponse: false,
  },
  getters: {
    getConversation: (state) => state.conversation,
    getIsWaitingForResponse: (state) => state.isWaitingForResponse,
  },
  mutations: {
    // ADD_MESSAGE(state, message) {
    //   state.conversation.push(message);
    // },
    ADD_MESSAGE(state, message) {
    state.conversation.push({
      ...message,
      helperText: message.helperText || null,
    });
  },
    RESET_CONVERSATION(state) {
      state.conversation = [];
    },
    SET_WAITING(state, status) {
      state.isWaitingForResponse = status;
    },
  },
  actions: {
    // addUserMessage({ commit }, text) {
    //   commit("ADD_MESSAGE", {
    //     type: "user",
    //     text,
    //     timestamp: new Date(),
    //   });
    // },

    addUserMessage({ commit }, text) {
    commit("ADD_MESSAGE", {
      type: "user",
      text,
      helperText: null,
      timestamp: new Date(),
    });
  },

    // addBotMessage({ commit }, text) {
    //   commit("ADD_MESSAGE", {
    //     type: "bot",
    //     text,
    //     timestamp: new Date(),
    //   });
    // },

    addBotMessage({ commit }, payload) {
    // payload will be { text, helperText }
    commit("ADD_MESSAGE", {
      type: "bot",
      text: payload.text || null,
      helperText: payload.helperText || null,
      timestamp: new Date(),
    });
  },

    resetChat({ commit }) {
      commit("RESET_CONVERSATION");
    },

    setWaiting({ commit }, status) {
      commit("SET_WAITING", status);
    },
  },
};
